jQuery(document).ready(function () {
  var swiper = new Swiper('.products-renders', {
    slidesPerView: 4,
    loop: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    autoplay: {
      delay: 2500,
    },
    breakpoints: {
      0: {
        slidesPerView: 1,
        spaceBetween: 10,
      },
      770: {
        slidesPerView: 2,
        spaceBetween: 50,
      },

      1023: {
        slidesPerView: 4,
        spaceBetween: 30,
      },
    },
  });
});
